import 'parsleyjs';

function FormValidator() {
  const self = this;

  self.init = function init(element) {
    const $el = $(element);

    if ($el.data('app-module-initialized')) return; // Prevent double init

    $el.attr('novalidate', true);
    $el.parsley({
      errorClass: 'is-invalid',
      successClass: 'is-valid',
      errorsContainer(Field) {
        let $parent = Field.$element.closest('.js-form-validate__field');
        if ($parent.length === 0) {
          $parent = Field.$element.parent();
        }
        return $parent.find('.js-form-validate__errors');
      },
      errorsWrapper: '<ul class="form-errors"></ul>',
      errorTemplate: '<li class="form-errors__item"></li>',
    });

    $el.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-form-validate').each(function init() {
      self.init(this);
    });
  };
}

export default new FormValidator();
